import createVueApp from '@phoenix/createVueApp';
import { PhxCollectionsBlock } from '@phx-styleguides/iwc';

document.querySelectorAll('.phoenix-collections-push').forEach((el) => {
  const app = createVueApp({});
  app.component('PhxCollectionsBlock', PhxCollectionsBlock);
  app.mount(el);
});
